import { CONNECTION_MAP, DeploymentEnvs } from "@castlefinance/vault-core";

// // // //

// Pull RPC endpoints from @castlefinance/vault-configs
// NOTE - this will be updated to pull the RPC connection string on a per-config basis
export const DEVNET_RPC = CONNECTION_MAP[DeploymentEnvs.devnetParity];
export const MAINNET_RPC = CONNECTION_MAP[DeploymentEnvs.mainnet];
